import { Theme } from '@mui/material';
import { defaultHostColorHex } from '../../pages/host/host-page.styles';

export const eventDatePickerStyles = (
	theme: Theme,
	primaryColor = defaultHostColorHex,
	backgroundColor = '#000000',
	lightTextColor?: string
) => ({
	datePicker: {
		backgroundColor: 'rgba(16,16,16,1)',
		color: '#FFFFFF',
		borderRadius: '8px',
		position: 'relative',
		border: `1px solid rgba(29,29,29,1)`,

		'& .MuiDayCalendar-weekDayLabel': {
			fontFamily: 'Integral CF',
			fontSize: '11px',
			fontWeight: 600,
			lineHeight: '16px',
			color: 'rgba(255, 255, 255, 0.7)',
			height: '24px',
		},

		'& .MuiDayCalendar-monthContainer': {
			'& .MuiPickersDay-root': {
				fontFamily: 'Montserrat',
				fontSize: '14px',
				fontWeight: 600,
				lineHeight: '16px',
				flexDirection: 'column',
				gap: '2px',
			},

			'& .MuiPickersDay-past': {
				color: '#FFFFFF99',

				'&.Mui-selected': {
					backgroundColor: '#000000',
					border: '1px solid #FFFFFF99',
				},
			},

			'& .MuiPickersDay-future': {
				color: '#FFFFFF',
			},

			'& .MuiPickersDay-today': {
				border: 0,
				color: primaryColor,
			},

			'& .MuiPickersDay-future, & .MuiPickersDay-today': {
				'&.Mui-selected': {
					color: '#FFFFFF',
					backgroundColor: primaryColor,
					border: '1px solid #FFFFFF',
				},
			},

			'& .MuiPickersDay-dayOutsideMonth': {
				color: 'rgba(255, 255, 255, 0.5)',
			},
		},
	},
	datePickerHeader: {
		p: '16px',
		display: 'flex',
		justifyContent: 'space-between',
	},
	datePickerIconButton: {
		width: '32px',
		height: '32px',
		color: '#FFFFFF',
	},
	louder: {
		position: 'absolute',
		top: '64px',
		left: 0,
		width: '100%',
		height: 'calc(100% - 64px)',
		background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0))',
		backdropFilter: 'blur(4px)',
		zIndex: 2,
	},
	datePickerTitle: {
		cursor: 'default',
		userSelect: 'none',
		fontFamily: 'Integral CF',
		fontSize: '16px',
		fontWeight: 400,
		lineHeight: '32px',
		color: '#FFFFFF',
	},
});
